/* eslint-disable */
import React from "react";
import { Link, useParams } from "react-router-dom";
import BreadCrumb from "components/Common/BreadCrumb/BreadCrumb";
import { useTranslation } from "react-i18next";

const OpportunityKanbanHeader = ({
  reloadList = () => {},
  jsonFilterQuery = [],
  selectedProcessId = null,
}) => {
  /* ------------- Language translation imports starts here ------------- */
  const { t } = useTranslation();

  /* ---- bread crumb text ---- */
  const breadcrumbText = [{ title: t("Opportunity") }];

  return (
    <div className="bg-white mt-3 mb-3">
      <div className="d-flex justify-content-between align-items-center flex-column flex-md-row g-2">
        <div className="ps-1">
          <BreadCrumb breadCrumbText={breadcrumbText} />
        </div>
        <div className="d-flex justify-content-md-end align-items-center gap-2 flex-wrap">
          {/* <!-- ========== Start refresh Section ========== --> */}
          <Link
            onClick={reloadList}
            to="#"
            className="btn btn-light border d-flex align-items-center px-3 py-2 rounded-3 shadow-sm"
            title={t("Reload")}
          >
            <span className="material-symbols-outlined icon-md me-1">
              refresh
            </span>
            <span className="fw-semibold small">{t("Reload")}</span>
          </Link>
          {/* <!-- ========== End refresh Section ========== --> */}

          {/* <!-- ========== Start view redirect Section ========== --> */}
          <div className="dropdown flex-fill flex-grow-sm-0">
            <button
              className="btn btn-light border d-flex align-items-center px-4 py-2 rounded-3 shadow-sm dropdown-toggle"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <span className="fw-semibold small">{t("Kanban View")}</span>
              <span className="material-symbols-outlined icon-lg ms-1">
                expand_more
              </span>
            </button>
            <ul className="dropdown-menu w-100 bg-white fs-sm border-0 rounded-3 shadow">
              <li>
                <Link
                  className="dropdown-item d-flex align-items-center gap-2 py-2"
                  to={`/admin/crm/opportunity/list`}
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    list
                  </span>
                  <span className="d-block">{t("List View")}</span>
                </Link>
              </li>
              {/* <li>
                <Link
                  className="dropdown-item d-flex align-items-center gap-2 py-2"
                  to={`/admin/crm/opportunity/kanban`}
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    view_kanban
                  </span>
                  <span className="d-block">Kanban View</span>
                </Link>
              </li> */}
              <li>
                <Link
                  className="dropdown-item d-flex align-items-center gap-2 py-2"
                  to={`/admin/crm/opportunity/kanbankit`}
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    view_kanban
                  </span>
                  <span className="d-block">{t("Kanban View")}</span>
                </Link>
              </li>
            </ul>
          </div>
          {/* <!-- ========== End view redirect Section ========== --> */}

          {selectedProcessId && (
            <Link
              to="#"
              // className="btn btn-light border d-flex align-items-center px-4 py-2 rounded-3 shadow-sm"
              className={`btn ${
                jsonFilterQuery.length > 0 && selectedProcessId
                  ? "btn-outline-primary"
                  : "btn-light border"
              } d-flex align-items-center px-4 py-2 rounded-3 shadow-sm`}
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#opportunityAdvFilter"
              aria-controls="opportunityAdvFilterLabel"
            >
              <span className="material-symbols-outlined icon-md me-1">
                tune
              </span>
              <span className="fw-semibold small">{t("Filter")}</span>
              <span
                className={
                  jsonFilterQuery.length > 0 && selectedProcessId
                    ? "bg-primary text-white ms-1 rounded-circle fs-xs"
                    : "d-none"
                }
                style={{ minWidth: 22, minHeight: 22 }}
              >
                {jsonFilterQuery.length}
              </span>
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default OpportunityKanbanHeader;
